import { render, staticRenderFns } from "./appFileUploader2.vue?vue&type=template&id=1072c85e"
import script from "./appFileUploader2.vue?vue&type=script&lang=js"
export * from "./appFileUploader2.vue?vue&type=script&lang=js"
import style0 from "./appFileUploader2.vue?vue&type=style&index=0&id=1072c85e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports